import Vue from "vue";

const state = {
  address: {
    label: "12321",
    address: "",
    apt_no: "",
    state: "",
    postcode: "",
    city: "",
    countryId: "",
    approved: 1
  },
  order: {
    addressId: ""
  },
  orders: [],
  total: 0,
  intentSecret: null,
  trackedShipment: {}

};

const getters = {};

const actions = {
  async CREATE_PAYMENT_INTENT({ commit, rootGetters }) {
    await Vue.prototype.$axios
      .post("/stripe/create-payment-intent", {
        amount: parseFloat(rootGetters["product/basketTotal"])
      })
      .then(res => {
        commit("SET_INTENT_SECRET", res.data.client_secret);
        return res.data.client_secret;
      });
  },
  async UPDATE_ORDER_STATUS({ commit }, payload) {
    await Vue.prototype.$axios.post("/orders/" + payload.orderId, payload);
    commit("SET_INTENT_EMPTY");
  },
  async CREATE_ORDER({ commit, rootState }, payload) {
    await Vue.prototype.$axios
      .post("/orders", {
        addressId: payload,
        phone: rootState.user.user.phone,
        email: rootState.user.user.email,
        products: rootState.product.basketProducts,
        specialRequest: null
      })
      .then(res => {
        commit("SET_ORDER", res.data.order);
        commit("SET_INTENT_SECRET", res.data.order.intent.client_secret);
      });
  },
  async UPDATE_SHIPPING_ADDRESS(context, payload) {
    await Vue.prototype.$axios.post("/shipment/" + payload.id, payload);
  },

  async TRACK_SHIPMENT({ commit }, trackingNumber) {
    await Vue.prototype.$axios
      .get("/shipments/tracking/" + trackingNumber)
      .then(response => {
        commit("SET_TRACKED_SHIPMENT", response.data.shipment);
      });
  },
  async GET_ORDERS({ commit }, payload) {
    await Vue.prototype.$axios
      .get("/orders?surgeryId=" + payload.surgeryId + "&from=" + payload.from + "&limit=" + payload.to)
      .then(res => {
        commit("LOAD_ORDERS", res.data.orders);
        commit("SET_TOTAL_ORDERS", res.data.meta.total);
      });
  },
  async GET_ORDER({ commit }, payload) {
    await Vue.prototype.$axios.get("/orders/" + payload).then(res => {
      commit("SET_ORDER", res.data.order);
    });
  },
  async CREATE_SUPPLIER_REVIEW(context, payload) {
    await Vue.prototype.$axios.post(
      "/suppliers/" + payload.supplierId + "/reviews",
      payload
    );
  }
};

const mutations = {
  SET_ORDER(state, payload) {
    state.order = payload;
  },
  LOAD_ORDERS(state, payload) {
    state.orders = payload;
  },
  SET_TOTAL_ORDERS(state, payload) {
    state.total = payload;
  },
  SET_INTENT_SECRET(state, payload) {
    state.intentSecret = payload;
  },
  SET_INTENT_EMPTY(state) {
    state.intentSecret = null;
  },
  SET_TRACKED_SHIPMENT (state, trackedShipment) {
    state.trackedShipment = trackedShipment
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
